/**
 * モーダル 動画
 */

export class IframeApi {
  constructor() {
    this.onInit();
  }
  onInit() {
    let tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
}

export class Modal {
  constructor(el) {
    this.DOM = {};
    this.DOM.movie = document.querySelector('.js-movie');
    this.DOM.openBtn = el;
    this.DOM.closeBtn = document.querySelector('.js-modal-closeBtn');
    this.DOM.modal = document.querySelector('.js-modal');
    this.DOM.modalContents =
      this.DOM.modal?.querySelector('.js-modal-contents');
    this.onInit();
  }
  onInit() {
    if (
      !this.DOM.openBtn ||
      !this.DOM.closeBtn ||
      !this.DOM.modal ||
      !this.DOM.modalContents
    )
      return;

    this.DOM.openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const videoId = this.DOM.openBtn.dataset.id;
      this.player = new YT.Player('js-player', {
        height: '585',
        width: '1040',
        videoId,
        playerVars: {
          rel: 0
        }
      });
      this._toggleModal(true);
    });

    this.DOM.closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this._toggleModal(false);
      this._stopVideo();
      this._removeVideo();
    });

    this.DOM.modal.addEventListener('click', (e) => {
      if (e.target === this.DOM.modal) {
        e.preventDefault();
        this._toggleModal(false);
        this._stopVideo();
        this._removeVideo();
      }
    });

    this.DOM.modalContents.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }
  _stopVideo() {
    if (this.player?.stopVideo) {
      this.player.stopVideo();
    }
  }
  _toggleModal(isOpen) {
    this.DOM.modal.classList.toggle('is-open', isOpen);
  }
  _removeVideo() {
    const newElement = document.createElement('div');
    newElement.className = 'js-movie';
    newElement.id = 'js-player';
    const oldElement = document.getElementById('js-player');
    oldElement.parentNode.replaceChild(newElement, oldElement);
  }
}
